import React from 'react';
import { motion } from 'framer-motion';
import backGround from '../../images/battle-map/land.jpg';

import pinTop from '../../images/battle-map/pin_top.svg';
import pinTopB from '../../images/battle-map/pin_top_blue.svg';
import pinBottom from '../../images/battle-map/pin_bottom.svg';
import clouds from '../../images/battle-map/clouds-min.png';
// icons start here
import Flags from '../../images/battle-map/flag2.png';
import Boston from '../../images/battle-map/boston.png';
import Tent from '../../images/battle-map/tent.png';
import Fort from '../../images/battle-map/fort.png';
import Axe from '../../images/battle-map/axe.png';
import FirePit from '../../images/battle-map/firepit.png';
import Boat from '../../images/battle-map/boat.png';
import Cannon from '../../images/battle-map/cannon2.png';
import Tower from '../../images/battle-map/tower.png';
import Barrel from '../../images/battle-map/barrel.png';
import Crossing from '../../images/battle-map/crossing.png';
import Gun from '../../images/battle-map/gun.png';
import Trees from '../../images/battle-map/trees.png';
import House from '../../images/battle-map/house.png';
import Surrender from '../../images/battle-map/surrender.png';
import Storm from '../../images/battle-map/storm.png';
// statics
import FlagsStatic from '../../images/battle-map/flag_static.png';
import BostonStatic from '../../images/battle-map/boston_static.png';
import TentStatic from '../../images/battle-map/tent_static.png';
import FortStatic from '../../images/battle-map/fort_static.png';
import AxeStatic from '../../images/battle-map/axe_static.png';
import FirePitStatic from '../../images/battle-map/firepit_static.png';
import BoatStatic from '../../images/battle-map/boat_static.png';
import CannonStatic from '../../images/battle-map/cannon_static.png';
import TowerStatic from '../../images/battle-map/tower_static.png';
import BarrelStatic from '../../images/battle-map/barrel_static.png';
import CrossingStatic from '../../images/battle-map/crossing_static.png';
import GunStatic from '../../images/battle-map/gun_static.png';
import TreesStatic from '../../images/battle-map/trees_static.png';
import HouseStatic from '../../images/battle-map/house_static.png';
import SurrenderStatic from '../../images/battle-map/surrender_static.png';
import StormStatic from '../../images/battle-map/storm_static.png';

class Largemap extends React.Component {
  constructor(props) {
    super(props);

    this.updateMap = this.updateMap.bind(this);

    this.state = { x: this.props.x, y: this.props.y };
    this.state = { introHasPlayed: false, hovering: 'none' };
  }

  updateMap() {
    this.setState({ introHasPlayed: true });
    console.log(this.props.isMobile);
    console.log('update map called');
  }

  componentDidUpdate() {
    console.log(this.props.currentBattle);
  }
  render() {
    const { leaderRead, onSelect, onDrag } = this.props;
    return (
      <motion.div
        animate={{
          scale: this.props.zoom,
          x: this.state.introHasPlayed
          ? this.props.x
          : this.props.isMobile
            ? [0, -1755, -1525, -1225, -450,-350, 100, 681]
            : [0, -1325, -1325, -1125, -200, -200, 100, 800],

        y: this.state.introHasPlayed
          ? this.props.y
          : this.props.isMobile
            ? [0, 100, 200, 250, -550, -350, 0, 380]
            : [0, 100, 200, 250, -450, -450, 0, 378]
      }}

        transition={{ duration: this.state.introHasPlayed ? 1 : 16.5, delay: this.state.introHasPlayed ? 0 : 5 }}
        onAnimationComplete={this.updateMap}
        drag
        dragConstraints={
          this.props.isMobile
            ? { top: -600, left: -2060, right: 800, bottom: 380 }
            : { top: -600, left: -1700, right: 800, bottom: 380 }
        }
        dragElastic={0.0}
        onDrag={() => {
          onDrag(this);
        }}
        id="gl"
        style={{ backgroundImage: `url(${backGround})` }}
      >
        <motion.div
          id="pin"
          className="boston"
          onClick={() => {
            this.props.onPin(3, -1700, 660);
          }}
          animate={
            this.props.currentBattle === 3 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 0.4,
          }}
        >
          <div className="battleTxt">Siege of Boston</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b4"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Boston' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Boston' ? Boston : BostonStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="princeton"
          onClick={() => {
            this.props.onPin(11, -765, 600);
          }}
          animate={{ opacity: 1 }}
          animate={
            this.props.currentBattle === 11 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 2.2,
          }}
        >
          <div className="battleTxt">Battle of Princeton</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b12"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Gun' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Gun' ? Gun : GunStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="brandywine"
          onClick={() => {
            this.props.onPin(12, -426, 349);
          }}
          animate={
            this.props.currentBattle === 12 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 2.3,
          }}
        >
          <div className="battleTxt">Battle of Brandywine</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b13"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Flags' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Flags' ? Flags : FlagsStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="ftwashington"
          onClick={() => {
            this.props.onPin(8, -1125, 632);
          }}
          animate={
            this.props.currentBattle === 8 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 1.9,
          }}
        >
          <div className="battleTxt">Battle of Fort Washington</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b9"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Tower' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Tower' ? Tower : TowerStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="ftlee"
          onClick={() => {
            this.props.onPin(9, -1083, 660);
          }}
          animate={
            this.props.currentBattle === 9 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{ duration: 1, delay: this.state.introHasPlayed ? 0 : 2 }}
        >
          <div className="battleTxt">Evacuation of Fort Lee</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b10"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Barrel' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Barrel' ? Barrel : BarrelStatic}
            />

            <img src={pinTop} alt="pintop" />
          </motion.div>

          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="harlem"
          onClick={() => {
            this.props.onPin(6, -1019, 585);
          }}
          animate={
            this.props.currentBattle === 6 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 1.7,
          }}
        >
          <div className="battleTxt">Battle of Harlem Heights</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <img src={pinTop} alt="pintop" />
            <motion.img
              id="b7"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Cannon' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Cannon' ? Cannon : CannonStatic}
            />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="trenton"
          onClick={() => {
            this.props.onPin(10, -837, 543);
          }}
          animate={
            this.props.currentBattle === 10 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 2.1,
          }}
        >
          <div className="battleTxt">First Battle of Trenton</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b11"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Crossing' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={
                this.state.hovering === 'Crossing' ? Crossing : CrossingStatic
              }
            />

            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="whiteplanes"
          onClick={() => {
            this.props.onPin(7, -1164, 660);
          }}
          animate={
            this.props.currentBattle === 7 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 9,
            delay: this.state.introHasPlayed ? 0 : 1.8,
          }}
        >
          <div className="battleTxt">Battle of White Plains</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b38"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Storm' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Storm' ? Storm : StormStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="germantown"
          onClick={() => {
            this.props.onPin(13, -681, 379);
          }}
          animate={
            this.props.currentBattle === 13 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 2.4,
          }}
        >
          <div className="battleTxt">Battle of Germantown</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b14"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Trees' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Trees' ? Trees : TreesStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="brooklyn"
          onClick={() => {
            this.props.onPin(4, -1123, 495);
          }}
          animate={
            this.props.currentBattle === 4 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 1.5,
          }}
        >
          <div className="battleTxt">Battle of Brooklyn</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b5"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'FirePit' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'FirePit' ? FirePit : FirePitStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="kipsbay"
          onClick={() => {
            this.props.onPin(5, -1147, 591);
          }}
          animate={
            this.props.currentBattle === 5 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 1.6,
          }}
        >
          <div className="battleTxt">Battle of Kip’s Bay</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b6"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Boat' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Boat' ? Boat : BoatStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="monmouth"
          onClick={() => {
            this.props.onPin(14, -1032, 443);
          }}
          animate={
            this.props.currentBattle === 14 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 0.8,
          }}
        >
          <div className="battleTxt">Battle of Monmouth</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b15"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'House' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'House' ? House : HouseStatic}
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="mononga"
          onClick={() => {
            this.props.onPin(2, 1173, 568);
          }}
          animate={
            this.props.currentBattle === 2 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 0.3,
          }}
        >
          <div className="battleTxt">Battle of Monongahela</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b3"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Axe' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Axe' ? Axe : AxeStatic}
            />
            <img src={pinTopB} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="jumonville"
          onClick={() => {
            this.props.onPin(0, 1300, 455);
          }}
          animate={
            this.props.currentBattle === 0 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{ duration: 1, delay: this.state.introHasPlayed ? 0 : 1 }}
        >
          <div className="battleTxt">Skirmish at Jumonville Glen</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b1"
              style={{ opacity: 1 }}
              className="pinIcon"
              whileHover={{ opacity: 1 }}
              onHoverStart={() => {
                this.setState({ hovering: 'Tent' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Tent' ? Tent : TentStatic}
            />
            <img src={pinTopB} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="necessity"
          onClick={() => {
            this.props.onPin(1, 1267, 453);
          }}
          animate={
            this.props.currentBattle === 1 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 0.2,
          }}
        >
          <div className="battleTxt">Battle of Fort Necessity</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b2"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Fort' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={this.state.hovering === 'Fort' ? Fort : FortStatic}
            />
            <img src={pinTopB} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>

        <motion.div
          id="pin"
          className="yorktown"
          onClick={() => {
            this.props.onPin(15, -215, -365);
          }}
          animate={
            this.props.currentBattle === 15 || this.props.sideBarOpen === false
              ? { opacity: 1 }
              : { opacity: 0.25 }
          }
          transition={{
            duration: 1,
            delay: this.state.introHasPlayed ? 0 : 2.6,
          }}
        >
          <div className="battleTxt">Siege of Yorktown</div>
          <motion.div
            className="pinTop"
            whileHover={{ scale: 2.3 }}
            whileTap={{ scale: 0.9 }}
          >
            <motion.img
              id="b16"
              style={{ opacity: 1 }}
              className="pinIcon"
              onHoverStart={() => {
                this.setState({ hovering: 'Surrender' });
              }}
              onHoverEnd={() => {
                this.setState({ hovering: 'none' });
              }}
              src={
                this.state.hovering === 'Surrender'
                  ? Surrender
                  : SurrenderStatic
              }
            />
            <img src={pinTop} alt="pintop" />
          </motion.div>
          <div className="pinBottom">
            <img src={pinBottom} alt="pinBottom" />
          </div>
        </motion.div>
        <motion.div className="clouds">
          <motion.img src={clouds} alt="clouds"
            animate={{ scale: 2.8, opacity: .2 }}
            transition={{ duration: 9, delay: 5 }}
          />
        </motion.div>
      </motion.div>
    );
  }
}

export default Largemap;
